module.exports = __webpack_public_path__ + "img/red.5c45068d.png";